import React, { FunctionComponent, ReactNode } from 'react';

export const toPxString = (x: number): string => `${x}px`;

export const toPercentageString = (x: number): string | Error => {
  if (x > 1 || x < 0) {
    return Error('x must be between 0 and 1');
  }

  return `${x * 100}%`;
};

export interface StyledProps {
  children?: ReactNode;
  className?: string;
}

// This exists so we do not pass react props into a dom element, like if we just did styled('span', ...) directly.
export const DivComponent: FunctionComponent<StyledProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

export const SpanComponent: FunctionComponent<StyledProps> = ({ children, className }) => (
  <span className={className}>{children}</span>
);
